import { post } from 'src/lib/http';
import { HttpPrefix } from 'src/lib/wemeet-http-moudle';
import { GuestItem } from '../pages/event/[eventid]/members/guest/index.page';
import { Response } from './type';

/**
 * @deprecated 请使用接口文档中的类型
 */
export interface GuestInfo {
  avatar: string;
  name: string;
  company: string;
  phone: string;
  email?: string;
  position?: string;
  describe?: string;
  guest_id?: string;
  event_id: string;
  host_id?: string;
  area_code?: string;
}

/**
 * @deprecated 请使用接口文档中的类型
 */
export interface GuestListData {
  guests: Array<GuestInfo>;
}

/**
 * @deprecated 请使用接口文档中的类型
 */
export interface GuestListRes {
  code: number;
  msg: string;
  data: GuestListData;
}

/**
 * @deprecated 请使用接口文档中的类型
 */
export interface AddOrModifyGustReq extends GuestItem {
  avatar_cos_key: string;
  sync_guest?: boolean;
}

/**
 * @deprecated 请使用接口文档中的类型
 * @param data
 */
export const addOrModifyGuest = (data: AddOrModifyGustReq) => {
  const path = data.guest_id
    ? '/v2/activities/dashboard/guest/edit-guest'
    : '/v2/activities/dashboard/guest/add-guest';
  return new Promise<Response>((resolve, reject) => {
    post<Response>(HttpPrefix.WEMEET_TAPI, path, data).then(
      (res) => {
        const { code } = res;
        if (code === 0) {
          resolve(res);
        } else {
          reject(res);
        }
      },
      (e) => {
        console.log('addOrModifyGuest error', e);
        reject(e);
      },
    );
  });
};

/**
 * @deprecated 请使用接口文档中的类型
 * @param guest_id
 * @param event_id
 */
export const deleteGuest = (guest_id: number | string, event_id: string) => {
  const path = '/v2/activities/dashboard/guest/remove-guest';
  return new Promise<Response>((resolve, reject) => {
    post<Response>(HttpPrefix.WEMEET_TAPI, path, {
      guest_id,
      event_id,
    }).then(
      (res) => {
        const { code } = res;
        if (code === 0) {
          resolve(res);
        } else {
          reject(res);
        }
      },
      (e) => {
        console.log('addOrModifyGuest error', e);
        reject(e);
      },
    );
  });
};
